import { PlotQueryInput } from 'common/graphqlTypes';
import { LRQRequest } from 'hooks/useLRQ/useLRQ';
import LRQRequestManager from 'components/common/Managers/LRQRequestManager';

// Mapping structure from plot/breakdown/pquery to LRQ request ID
export type LRQId = {
  graphIndex: number;
  plotIndex:  number;
  id:         string;
  plotQuery?: PlotQueryInput;
  request?:   LRQRequest;
  shift?:     string;
};

/**
 * Dig through the mapping list and return the LRQ request id for a plot/breakdown/pquery
 *
 * @param idList      The list of request ids for all the graphs on this dashboard
 * @param graphIndex  Which graph to find the ids for
 */
export const getGraphDataIds = (idList: LRQId[], graphIndex: number): string[] => idList.filter((LRQId) => LRQId.graphIndex === graphIndex).map((LRQId) => LRQId.id);

export type DashboardStateProps = {
  requests: LRQRequest[];
  launchDashboard?: boolean;
};

/**
 * All the real work for LRQ is done in the LRQRequestManager
*/
function DashboardRequestManager({ requests }: DashboardStateProps): JSX.Element {
  return (
    <>{(requests as LRQRequest[]).map((request) => (<LRQRequestManager key={request.key} request={request} launchDashboard={true}/>))}</>
  );
}

export default DashboardRequestManager;
